import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OAuthStorage } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

const waybillsBearerToken = "e959fda0-6f75-3007-b436-3f8728eb76b8";

@Injectable({
  providedIn: 'root'
})
export class OAuthInterceptor implements HttpInterceptor {

  urls: string[] = [environment.shipmentApiUrl, environment.waybillsApiUrl, environment.agenciesApiUrl, environment.settlementsApiUrl, environment.logisticsDocumentsApiUrl, environment.gatewayUrl];

  constructor(private authStorage: OAuthStorage) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let url = req.url.toLowerCase();
    if (!this.requiresAccessToken(url)) return next.handle(req);

    let authorizationHeader = this.getAuthorizationHeader(url);
    let headers = req.headers.set('Authorization', authorizationHeader);
    req = req.clone({ headers });
    return next.handle(req);
  }

  requiresAccessToken(url: string): boolean {
    let found = this.urls.find(u => url.startsWith(u));
    return !!found;
  }

  getAuthorizationHeader(url: string) {
    const allowdUrls = [environment.shipmentApiUrl, environment.agenciesApiUrl, environment.settlementsApiUrl, environment.logisticsDocumentsApiUrl, environment.gatewayUrl];
    const matchedUrl = allowdUrls.find(allowedUrl => url.startsWith(allowedUrl));
    let authorizationHeader: string = '';
    if (matchedUrl === undefined) {
      return authorizationHeader;
    }
    if (matchedUrl === environment.waybillsApiUrl) {
      
      authorizationHeader = 'Bearer ' + waybillsBearerToken;
      return authorizationHeader;
    }
    return authorizationHeader = 'Bearer ' + this.authStorage.getItem('access_token');
  }
}
